import { Button } from '@mm/components';
import React from 'react';
import { ReactComponent as G2BadgeTop50 } from 'assets/top50-2023.svg';
import dataTestAccuracySrc from './images/data-test-accuracy.png';
import explainerSrc from './images/explainer.png';
import { ReactComponent as Inc500 } from 'assets/inc-500.svg';
import { ReactComponent as BestROI2025 } from 'assets/best-roi-2025.svg';
import { ReactComponent as Leader2025 } from 'assets/leader-2025.svg';
import { ReactComponent as UsersLoveUsIcon } from 'assets/users-love-us.svg';
import { ReactComponent as Iconiq } from 'assets/iconiq.svg';
import styles from './StaticContent.module.css';
import { Partners } from '../Partners/Partners';
import {
  beautifyNumber,
  WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY,
} from '../WebsiteReportSummary/constants';

export const StaticContent = ({
  onClick,
  traffic,
  websiteURL,
  isWhiteLabel,
}: {
  onClick: () => void;
  traffic: number;
  websiteURL: string;
  isWhiteLabel?: boolean;
}) => (
  <div className={styles.container}>
    <div className={styles.deliverabilityBlock}>
      <div className={styles.description}>
        <div className={styles.titleKalam}>
          Learn the Truth about Website Visitor Identification Fraud
        </div>
        <div className={styles.title}>
          Email deliverability and the identity resolution industry
        </div>
        <div className={styles.text}>
          Independent tests by brands and first-party data providers graded the
          accuracy of top anonymous website visitor identity resolution tools
          and found 3 of 4 providers to be 75-95% wrong.*
        </div>
        {!isWhiteLabel && (
          <Button onClick={onClick} css={{ container: styles.button }}>
            Test the Visitor ID Accuracy on My Site
          </Button>
        )}
      </div>
      <div className={styles.image}>
        <div className={styles.text}>
          Accuracy of Top 4 ID Resolution Providers
        </div>
        <img src={dataTestAccuracySrc} />
      </div>
    </div>
    <div className={styles.badges}>
      <div className={styles.titles}>
        <div className={styles.titleKalam}>Our Awards</div>
        <div className={styles.title}>Recognized by industry leaders</div>
      </div>
      <div className={styles.badgesRow}>
        <Inc500 />
        <Iconiq style={{ width: 104, height: 130 }} />
        <Leader2025 />
        <G2BadgeTop50 style={{ width: 114, height: 128 }} />
        <BestROI2025 />
        <UsersLoveUsIcon />
      </div>
    </div>
    <div className={styles.explainer}>
      <div className={styles.opportunities}>
        <div className={styles.highlighted}>
          {' '}
          <span>
            {beautifyNumber(traffic * WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY)}
          </span>{' '}
          additional emails
        </div>
        <div className={styles.text}>
          Customers.ai could have collected from visitors to{' '}
          <span className={styles.website}>{websiteURL}</span> this month
        </div>
      </div>
      <img src={explainerSrc} />
    </div>
    <Partners />
  </div>
);
